module.exports = __webpack_public_path__ + "img/feature3-2x.042e8db.png";